import axios from '@/services/axios';

// 生成检索式
export const searchTermApi = (word: string, config?: any) =>
  axios.get(`/llm/searchTerm?word=${word}`, config);

// 语义生成检索式
export const textToSearches = (searches: string, config?: any) =>
  axios.post(`/llm/textToSearches`, { searches }, config);

// 检索式检查
export const searchesCheckApi = (searches: string): Promise<Res.searchesCheckApi> =>
  axios.post(`/llm/searches/check`, { searches });

// 获取商务信息
export const GetContactOur = (): Promise<Res.GetContactOur> =>
  axios.post(`/admin/v1/GetContactOur`);
